export default __webpack_public_path__ + "static/media/client-dislike.ea83bc6b.png";